import React from 'react';

import PropTypes from 'prop-types';

import Downshift from 'downshift';
import FormFeedback from 'reactstrap/lib/FormFeedback';
import FormText from 'reactstrap/lib/FormText';

import styles from './styles.module.scss';

class MultiSelectDropdownAtom extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleToggleMenu = this.handleToggleMenu.bind(this);
    this.state = {
      isOpen: false,
      selectedItems: props.input.value || [],
      items: props.items || [],
      inputValue: ""
    };
  }


  componentWillReceiveProps(nextProps) {
    this.setState({items: nextProps.items});
    const {selectedItems} =this.state
    if(nextProps.input.value !== this.props.input.value){
      this.setState({ selectedItems: nextProps.input.value ? nextProps.input.value : [] });
    }
    if(JSON.stringify(nextProps.items) !==JSON.stringify(this.props.items)){
      const updatedSelectedItem = selectedItems.filter((item)=>{
        if(nextProps.items.findIndex(e => e.name.trim() === item.name.trim())>-1){
          return true
        }else {
          return false
        }
      })
      this.setState({selectedItems:updatedSelectedItem})
      nextProps.input.onChange([...updatedSelectedItem]);
    }
  }

  handleChange(item) {
    const { selectedItems } = this.state;
    if (selectedItems.filter(i => item.id === i.id).length) {
      this.removeItem(item);
    } else {
      this.addSelectedItem(item);
    }
  }

  handleInputChange(e) {
    const { itemToString } = this.props;
    this.setState({inputValue: e.target.value})
    const rx = new RegExp(e.target.value, 'gi');
    e.stopPropagation();
    this.setState({ items: this.props.items.filter(i => itemToString(i).match(rx)) });
  }

  addSelectedItem(item) {
    const { input } = this.props;
    this.props.addItem && this.props.addItem(item);
    this.setState({inputValue: ""});
    this.setState({items: this.props.items});
    this.setState(({selectedItems}) => ({
      selectedItems: [...selectedItems, item],
    }));
    input.onChange([...this.state.selectedItems, item]);
  }

  /* eslint-disable */
  removeItem(item) {
    const { input } = this.props;
    this.props.removedItem && this.props.removedItem(item);
    this.setState(({ selectedItems }) => {
      return {
        selectedItems: selectedItems.filter(i => item.id !== i.id),
      };
    });
    input.onChange(this.state.selectedItems.filter(i => item.id !== i.id));
  }
  /* eslint-enable */

  // handleStateChange(changes) {
  //   const { isOpen, type } = changes;
  //   if (type === Downshift.stateChangeTypes.mouseUp) {
  //     this.setState({ isOpen });
  //   }
  // }

  handleToggleMenu() {
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
  }

  render() {
    const {
      input,
      label,
      id,
      itemToString,
      help,
      placeholder,
      meta: { touched, error },
    } = this.props;
    const { isOpen, items, selectedItems, inputValue } = this.state;
    const filteredSelected = selectedItems.filter((elem) => items.find(({ id }) => elem.id === id));
    console.log(filteredSelected)
    return (
      /* eslint-disable */
      <Downshift
        itemToString={itemToString}
        onSelect={this.handleChange}
        // onStateChange={this.handleStateChange}
        defaultSelectedItem={filteredSelected}
        selectedItem={filteredSelected}
        isOpen={isOpen}
        onOuterClick={this.handleToggleMenu}
        render={({
          getInputProps,
          getButtonProps,
          getItemProps,
          getLabelProps,
          isOpen,
          selectedItem,
          highlightedIndex,
        }) => {
          return (<div style={{ position: 'relative' }} className="custom-multi-select">
            {label &&
              <label
                {...getLabelProps({
                  htmlFor: id,
                  className: 'col-form-label',
                  style: { width: '100%' },
                })}
              >
                {label}
              </label>
            }
            {/* eslint-enable */}
            <div
              {...getButtonProps({
                className: `${styles['multi-select']} muti-select-wrap`,
                onClick: this.handleToggleMenu,
              })}
            >
              <div className={styles['multi-select__content']}>
                {selectedItem && selectedItem.length > 0 &&
                  selectedItem.map(item =>
                    <label
                      key={item.id}
                      className={styles['multi-select__chip']}
                      htmlFor="chip"
                    >
                      {itemToString(item)}
                      <span
                        className="pointer"
                        role="button"
                        tabIndex="0"
                        onClick={e => {
                          e.stopPropagation();
                          this.removeItem(item);
                        }}
                      >
                        &nbsp;x
                      </span>
                    </label>,
                  )
                }
                <input
                  {...getButtonProps({
                    placeholder: selectedItem.length ? '' : placeholder,
                    onChange: this.handleInputChange,
                    onClick: (e) => {
                      if (isOpen) e.stopPropagation();
                    },
                    value: inputValue,
                    className: styles['multi-select__input']
                  })}
                  data-lpignore={true}
                  autoComplete="off"
                />
              </div>
            </div>
            <span onClick={this.handleToggleMenu} style={{ position: 'absolute' }} className="dropdown-arrow d-inline-block" />
            {isOpen ? (
              <div className={styles['multi-select__dropdown']}>
                {items.length
                  ? items.map((item, index) => (
                    <div
                      key={item.id}
                      {...getItemProps({item})}
                      style={{
                        backgroundColor:
                          highlightedIndex === index ? '#9CDAD7' : 'white',
                        fontWeight: filteredSelected.filter(i => item.id === i.id).length > 0
                          ? 'bold' : 'normal',
                        lineHeight: '1.1',
                        fontSize: '14px',
                        padding: '0.5rem',
                      }}
                      className="cursor-pointer"
                    >
                      {itemToString(item)}
                    </div>
                  ))
                  : <div className={styles['multi-select__no-results']}>No Results Found</div>
                }
              </div>
            ) : null}
            <FormText color="muted">{help}</FormText>
            <FormFeedback>{touched && error}</FormFeedback>
          </div>);
        }}
      />
    );
  }
}

MultiSelectDropdownAtom.propTypes = {
  items: PropTypes.array,
  onChange: PropTypes.func,
  itemToString: PropTypes.func,
};

export default MultiSelectDropdownAtom;
